var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[
    'sidebar__link',
    'sidebar__link--small',
    { 'sidebar__link--active': _vm.activeFilter == _vm.data },
    { 'sidebar__link--disabled': !_vm.source.length } ],on:{"click":function($event){$event.preventDefault();return _vm.setFilter(_vm.data)}}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.source.length > 0)?_c('span',{staticClass:"filter__badge"},[_vm._v(_vm._s(_vm.source.length))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }